import { computed, useScript } from '#imports'

export const useMobilepayScript = () => {
    const script = useScript({
        id: 'js-mobilepay-sdk',
        src: 'https://checkout.vipps.no/checkout-button/v1/vipps-checkout-button.js',
        crossorigin: false,
    }, {
        trigger: 'manual',
    })

    const isLoaded = computed(() => script.status.value === 'loaded')

    return { ...script, isLoaded }
}
